module.exports = __webpack_public_path__ + "img/piattaformaverde.235709de.png";